import React from "react";
import { Container } from "react-bootstrap";
import styled from "styled-components";

// Define the styled spinner component with small size
const Spinner = styled.div`
  position: relative;
  width: 10px; /* Adjusted width for small size */
  height: 10px; /* Adjusted height for small size */

  div {
    animation: spinnerAnimation 1.875s infinite backwards;
    background-color: #474bff;
    border-radius: 50%;
    height: 100%;
    position: absolute;
    width: 100%;
  }

  div:nth-child(1) {
    animation-delay: 0.15s;
    background-color: rgba(71, 75, 255, 0.9);
  }

  div:nth-child(2) {
    animation-delay: 0.3s;
    background-color: rgba(71, 75, 255, 0.8);
  }

  div:nth-child(3) {
    animation-delay: 0.45s;
    background-color: rgba(71, 75, 255, 0.7);
  }

  div:nth-child(4) {
    animation-delay: 0.6s;
    background-color: rgba(71, 75, 255, 0.6);
  }

  div:nth-child(5) {
    animation-delay: 0.75s;
    background-color: rgba(71, 75, 255, 0.5);
  }

  @keyframes spinnerAnimation {
    0% {
      transform: rotate(0deg) translateY(-200%);
    }
    60%, 100% {
      transform: rotate(360deg) translateY(-200%);
    }
  }
`;

function LoadingPage() {
  return (
    <Container>
      <div>
        <Spinner>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </Spinner>
        {/* <p style={{ marginTop: '40px', transform: 'translate(-50%,-50%)' }}>Loading...</p> */}
      </div>
    </Container>
  );
}

export default LoadingPage;
